/* IMPORT */
import Scheduler from '../objects/scheduler.async.js';
import { Stack } from './debugger.js';
/* MAIN */
const tick = (stack) => {
    Scheduler.flush(stack);
};
/* EXPORT */
export default tick;
